// extracted by mini-css-extract-plugin
export var black = "_2u-6";
export var brand = "_2u-1";
export var ddefault = "_2u-0";
export var error = "_2u-3";
export var gray = "_2u-2";
export var highContrast = "_2u-8";
export var outline = "_2u-7";
export var success = "_2u-5";
export var warning = "_2u-4";